import React, { useContext, useState, useEffect } from "react";
import { Layout, Menu, Typography, Drawer, Button, Modal, Card, Input, message, Badge, Row, Col, Statistic } from "antd";
import {
  DashboardOutlined,
  FieldTimeOutlined,
  ScheduleOutlined,
  HourglassOutlined,
  CalendarFilled,
  ClockCircleFilled,
  FileProtectOutlined,
  RedoOutlined,
  GiftOutlined,
  WalletOutlined,
  TeamOutlined,
  ClusterOutlined,
  BarChartOutlined,
  ExclamationCircleOutlined,
  CheckSquareOutlined,
  UsergroupAddOutlined,
  InboxOutlined,
  FieldBinaryOutlined,
  SyncOutlined,
  ApartmentOutlined,
  ExperimentOutlined,
  SafetyCertificateOutlined,
  WarningOutlined,
  FileTextOutlined,
  LineChartOutlined,
  UserAddOutlined,
  FileAddOutlined,
  FileSearchOutlined,
  AuditOutlined,
  CustomerServiceOutlined,
  PlusCircleOutlined,
  FolderViewOutlined,
  NotificationOutlined,
  ThunderboltOutlined,
  MoreOutlined,
  LogoutOutlined,
  FileDoneOutlined,
  FormOutlined,
  MenuOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  FundOutlined,
  CheckCircleOutlined
} from "@ant-design/icons";

import UserImg from "../../assests/user_avatar.png"
import { AuthContext } from "../../context/AuthContext";
import DashboardHeader from "../../components/dashboardheader/DashboardHeader";
import Footer from "../../components/footer/Footer";
import CreateMrf from "./CreateMrf";
import EmployeeViewReq from "./EmployeeViewReq";
import InterviewPage from "../interviewpage/InterviewPage";
import Holidays from "./Holidays";
import ViewAnnouncement from "../../components/employee/ViewAnnouncement";
import OffDay from "../../components/employee/OffDay";
import Permission from "../../components/employee/Permission";
import Leaves from "../../components/employee/Leaves";
import Teamleaves from "../../components/Teamleaves";
import TeamCompoff from "../../components/employee/TeamCompoff";
import Welcome from "../../components/Welcome";
import TeamPermissions from "../../components/TeamPermissions";
import RaiseTicket from "../../components/employee/RaiseTicket";
import ViewTicket from "../../components/employee/ViewTicket";
import PaySlip from "../../components/PaySlip";
import axios from "axios";
import TeamAttendance from "../../components/TeamAttendance";
import ViewEmpAttendance from "../../components/attendance/viewEmpAttendance";
import WeekOffCancel from "../../components/employee/WeekOffCancel";
import Rfc from "../../components/Rfc";
import ProbationReview from "../../components/employee/ProbationReview";
import SelfAssessment from "../../components/selfAssessment";
import BirthDayTemplate from "../../components/BirthDayTemplate";
import ViewBirthDay from "../../components/ViewBirthDay";
import WorkAnniversary from "../../components/WorkAnniversary";
import WorkCard from "../../components/WorkCard";
import OverallEmployees from "../../components/employee/OverallEmployees";
import Otapplication from "../../components/employee/Otapplication";
import OtApprovals from "../../components/OtApprovals";
import ListTickets from "../../components/ListTickets";
import "./EmployeeDashboard.css"
import TeamAssessment from "../TeamAssessment";
import Resignation from "../Resignation";
import ResignationRequests from "../ResignationRequests";
import LeaveCalendar from "../../components/employee/LeaveCalendar";
import { motion } from "framer-motion";
import EmployeeProfile from "../EmployeeProfile";
import Pips from "./Pips";
import InduvidualAttendance from "./InduvidualAttendance";
import Title from "antd/es/skeleton/Title";
import OrgChart from "../OrgChart";
import ListNoc from "../ListNoc";
import ExitInterview from "../ExitInterview";
import PastOnduty from "./PastOnduty";
import TeamMembers from "../hod/TeamMembers";
import MyRfc from "../../components/employee/MyRfc";
import OnDutyAttendance from "../../components/OndutyAttendance";
import AppliedOnDuty from "./AppliedOnDuty";


const today = new Date();
const formattedDate = today.toLocaleDateString('en-GB');
console.log(formattedDate);

const { Sider, Content } = Layout;
const { TextArea } = Input;

export default function EmployeeDashboard() {
  const { authData, backUrl } = useContext(AuthContext);
  const [showWishes, setShowWishes] = useState(false);

  const [showWelcome, setShowWelcome] = useState(true);
  const [isHR, setIsHr] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [celebrations, setCelebrations] = useState({ birthdays: [], work_anniversaries: [] });
  const [eventsModalVisible, setEventsModalVisible] = useState(false);
  const [reportingEmployee, setReportingEmployee] = useState(null);
  const [showMRF, setShowMRF] = useState(false);
  const [isSuperUser, setIsSuperUser] = useState(false);
  const [wishModalVisible, setWishModalVisible] = useState(false);
  const [wishMessage, setWishMessage] = useState("");
  const [mywishes, setMyWishes] = useState([]);
  const [selectedPerson, setSelectedPerson] = useState(null);

  const [showProfile, setShowProfile] = useState(false)
  const [isHovered, setIsHovered] = useState(false);

  const [isEmployeeView, setIsEmployeeView] = useState(
    localStorage.getItem("Hrselected") === "employee"
  );

  const [checkData, setCheckData] = useState(null)

  const [wishes, setWishes] = useState([]);

  const isMobile = window.innerWidth < 480;
  const isTab = window.innerWidth < 768;

  const [selectedMenu, setSelectedMenu] = useState(() => {
    return localStorage.getItem("employeeDashboardPage") || "home";
  });

  useEffect(() => {
    localStorage.setItem("employeeDashboardPage", selectedMenu);
    if (authData?.employee?.is_superuser === true) {
      setIsSuperUser(true);
    }
  }, [selectedMenu]);

  useEffect(() => {
    const welcomeShown = localStorage.getItem("welcomeShown");
    if (welcomeShown) {
      setShowWelcome(true);
      setTimeout(() => {
        localStorage.setItem("welcomeShown", "false");
        setShowWelcome(false);
      }, 3000);
    }
  }, []);

  const fetchWishes = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/probation/celebrations/today/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setCelebrations(res.data);
    } catch (error) {
      console.error("Error fetching celebrations:", error);
    }
  };

  const [leaveDetails, setLeaveDetails] = useState(null);

  const getLeaveSummary = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/hr/leave-summary/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setLeaveDetails(res.data);
    }
    catch (error) {
      console.error("Error fetching leaves:", error);

    }
  }

  useEffect(() => {
    getLeaveSummary();
  }, []);

  const fetchMyWishes = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/probation/celebrations/my/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setMyWishes(res.data);
    } catch (error) {
      console.error("Error fetching celebrations:", error);
    }
  };

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const Cdata = localStorage.getItem("Hrselected");
        if (Cdata === "employee") setIsHr(true);
        else setIsHr(false);

        const res = await axios.get(
          `${backUrl}/api/emp/employees/${authData.employee.reporting_to}`,
          {
            headers: { Authorization: `Bearer ${authData?.access}` },
          }
        );
        setReportingEmployee(res.data);
      } catch (error) {
        console.error("Error fetching employee:", error);
      }
    };
    fetchEmployee();
    fetchWishes();
    fetchMyWishes();
  }, [authData, backUrl]);

  const checkEmployeeAccess = async () => {
    const res = await axios.get(`${backUrl}/api/emp/my-team/count/`, {
      headers: {
        Authorization: `Bearer ${authData?.access}`
      }
    });

    setCheckData(res.data)
    if (res.data.team_count !== 0 || authData?.employee?.is_hr === true) {
      setShowMRF(true)
    }
    else {
      setShowMRF(false)
    }
  }

  useEffect(() => {
    checkEmployeeAccess()
  }, []);

  const handleOpenWishModal = (person) => {
    setSelectedPerson(person);
    setWishModalVisible(true);
  };

  const handleSendWish = async () => {
    try { 
      const payload = {
        receiver_id: 343,
        occasion: "BIRTHDAY",
        message: "Happy Birthday Mithun! 🎉",
      };

      await axios.post(`${backUrl}/api/probation/celebrations/send/`, payload, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });

      message.success(`Wish sent successfully!`);
      setWishModalVisible(false);
      setWishMessage("");
    } catch (error) {
      console.error("Error sending wish:", error);
      message.error("Failed to send wish. Try again later.");
    }
  };

  const handleBack = () => {
    setShowProfile(false)
  }

  const LeaveSummary = ({ data }) => {
    const { allotments, balances, totals } = data;

    const statBox = (bg) => ({
      background: bg,
      padding: "16px",
      borderRadius: "10px",
      textAlign: "center",
      flex: "1",
      width: "100px"
    });

    const flexContainer = {
      display: "flex",
      flexWrap: "wrap",
      gap: "16px",
      width: "100%"
    };

    return (
      <div style={{ width: "100%", padding: 10 }}>

        {/* Allotments */}
        <Card title="Leave Allotments" style={{ marginBottom: 20 }}>
          <div style={flexContainer}>

            <div style={statBox("#ffdceacc")}>
              <Statistic
                title="Sick"
                value={allotments.SL}
                prefix="🤒"
              />
            </div>

            <div style={statBox("#ffcbffc1")}>
              <Statistic
                title="Casual"
                value={allotments.CL}
                prefix="🏖️"
              />
            </div>

            <div style={statBox("#ffffd9de")}>
              <Statistic
                title="Off"
                value={allotments.Compoff}
                prefix="🛌"
              />
            </div>

          </div>
        </Card>

        {/* Totals */}
        <Card title="Leaves Taken" style={{ marginBottom: 20 }}>
          <div style={flexContainer}>

            <div style={statBox("#ffdceacc")}>
              <Statistic
                title="SL Taken"
                value={totals.SL_Taken}
                prefix="🤒"
              />
            </div>

            <div style={statBox("#ffcbffc1")}>
              <Statistic
                title="CL Taken"
                value={totals.CL_Taken}
                prefix="🏖️"
              />
            </div>

            <div style={statBox("#d4f4ffc9")}>
              <Statistic
                title="Comp Off"
                value={totals.Compoff_Taken}
                prefix="🛌"
              />
            </div>

            <div style={statBox("#ffffd9de")}>
              <Statistic
                title="Week Off"
                value={totals.WeekOff_Taken}
                prefix="🛌"
              />
            </div>

          </div>
        </Card>

        {/* Balances */}
        <Card title="Leave Balances" style={{ marginBottom: 20 }}>
          <div style={flexContainer}>

            <div style={statBox("#ffdceacc")}>
              <Statistic
                title="Sick"
                value={balances.SL}
                prefix="🤒"
              />
            </div>

            <div style={statBox("#ffcbffc1")}>
              <Statistic
                title="Casual"
                value={balances.CL}
                prefix="🏖️"
              />
            </div>

            <div style={statBox("#ffffd9de")}>
              <Statistic
                title="Off"
                value={balances.Compoff}
                prefix="🛌"
              />
            </div>

          </div>
        </Card>

      </div>
    );
  };

  const menuItems = [
    { key: "home", icon: <DashboardOutlined />, label: "Dashboard" },
    {
      key: "attendance",
      icon: <FieldTimeOutlined />,
      label: "Attendance",
      children: [
        {
          key: "myattendance",
          icon: <ScheduleOutlined />,
          label: "View Attendance",
        },
        authData?.employee?.is_ot && {
          key: "otavail",
          icon: <HourglassOutlined />,
          label: "Over Time Apply",
        },
        // {
        //   key: "myrfc",
        //   icon: <HourglassOutlined />,
        //   label: "My Requests",
        // },
        {
          key: "applyOnduty",
          icon: <HourglassOutlined />,
          label: "Apply On Duty",
        },
        {
          key: "appliedOnDuty",
          icon: <HourglassOutlined />,
          label: "Applied On Duty",
        },
      ],
    },

    {
      key: "leaveManagement",
      icon: <CalendarFilled />,
      label: "Leave Management",
      children: [
        { key: "leaves", icon: <FileProtectOutlined />, label: "Leaves" },
        { key: "permissions", icon: <ClockCircleFilled />, label: "Permissions" },
        { key: "offDayDutyApply", icon: <RedoOutlined />, label: "Off Day Working" },
        { key: "holidays", icon: <GiftOutlined />, label: "Holidays" },
      ],
    },

    { key: "payslip", icon: <WalletOutlined />, label: "Payslip" },

    (showMRF || isSuperUser) && {
      key: "teamdetails",
      icon: <TeamOutlined />,
      label: "Team Details",
      children: [
        { key: "teamMembers", icon: <FileDoneOutlined />, label: "Team Members" },
        {
          key: "attendancee",
          icon: <ClusterOutlined />,
          label: "Attendance",
          children: [
            { key: "teamattendance", icon: <BarChartOutlined />, label: "Team Attendance" },
            { key: "rfc", icon: <ExclamationCircleOutlined />, label: "Request for Consideration" },
            {
              key: "otapproval",
              icon: <CheckSquareOutlined />,
              label: "Over Time Requests",
            },
            {
              key: "onduty",
              icon: <CheckSquareOutlined />,
              label: "Onduty Requests",
            },
          ],
        },
        {
          key: "leave",
          icon: <UsergroupAddOutlined />,
          label: "Team Leave Management",
          children: [
            { key: "leaveRequests", icon: <InboxOutlined />, label: "Leave Requests" },
            { key: "permissionRequests", icon: <FieldBinaryOutlined />, label: "Permission Requests" },
            { key: "compoffRequests", icon: <SyncOutlined />, label: "Team off day workings" },
          ],
        },
        {
          key: "lifecycle",
          icon: <ApartmentOutlined />,
          label: "Employee Life Cycle",
          children: [
            { key: "teamemployement", icon: <ExperimentOutlined />, label: "Probation" },
            { key: "overall", icon: <SafetyCertificateOutlined />, label: "Confirmed" },
            { key: "pips", icon: <WarningOutlined />, label: "Raised PIP Requests" },
            {
              key: "resignationRequests",
              icon: <FileTextOutlined />,
              label: "Resignation Requests",
            },
          ],
        },
      ],
    },

    // {
    //   key: "showselfassessments",
    //   icon: <LineChartOutlined />,
    //   label: "Team Assessments",
    // },

    {
      key: "recruitment",
      icon: <UserAddOutlined />,
      label: "Recruitment",
      children: [
        (showMRF && !isSuperUser) && {
          key: "applyMRF",
          icon: <FileAddOutlined />,
          label: "Apply MRF",
        },
        (showMRF && !isSuperUser) && {
          key: "viewRequisitions",
          icon: <FileSearchOutlined />,
          label: "View Requisitions",
        },
        { key: "interview", icon: <AuditOutlined />, label: "Interview & Assessment" },
      ],
    },

    {
      key: "ticketingSystem",
      icon: <NotificationOutlined />,
      label: "Ticketing System",
      children: [
        { key: "raiseTicket", icon: <PlusCircleOutlined />, label: "Raise Ticket" },
        { key: "viewTicket", icon: <FolderViewOutlined />, label: "View Ticket" },
        (authData?.employee?.department === 48 || authData?.employee.role === 2) && {
          key: "tickets",
          icon: <NotificationOutlined />,
          label: "Raised Tickets",
        },
      ],
    },

    authData?.pending_self_assessment && {
      key: "selfAssessment",
      icon: <ThunderboltOutlined />,
      label: <span className="glow-text">Self Assessment</span>,
    },

    // {
    //   key: "orgchart",
    //   icon: <ApartmentOutlined />,
    //   label: "ORG Chart",
    // },

    {
      key: "resignation",
      icon: <MoreOutlined />,
      label: "Others",
      children: [
        { key: "resignation", icon: <LogoutOutlined />, label: "Apply Resignation" },
        authData?.assigned_dept_head_id && {
          key: "NocClearence",
          icon: <FileDoneOutlined />,
          label: "NOC Clearance",
        },
        authData?.is_exit_interview_triggered && {
          key: "exitInterview",
          icon: <FormOutlined />,
          label: "Exit Interview",
        },
      ],
    },
  ];



  const renderContent = () => {
    switch (selectedMenu) {
      case "home":
        return showWelcome ? (
          <Welcome />
        ) : (
          <>
            {
              showProfile ? (
                <EmployeeProfile onBack={handleBack} />
              ) : (
                <div
                  style={{
                    background: "#ffffffff",
                    minHeight: "100vh",
                    padding: isMobile ? "16px" : "24px",
                  }}
                >
                  {authData?.your_under_pip && (
                    <div
                      className="d-flex align-items-center gap-3 mb-4"
                      style={{
                        background: "#fff3cd",
                        border: "1px solid #ffeeba",
                        padding: "16px",
                        borderRadius: "8px",
                      }}
                    >
                      <span style={{ fontSize: "22px" }}>⚠️</span>
                      <Typography.Title
                        level={4}
                        style={{
                          margin: 0,
                          color: "#856404",
                          fontWeight: "600",
                          fontSize: isMobile ? "14px" : "16px",
                        }}
                      >
                        You are currently under PIP — {authData?.pip_days_remaining} days remaining for review
                      </Typography.Title>
                    </div>
                  )}

                  <div className="container-fluid px-0" style={{ maxWidth: "1500px", margin: "0 auto" }}>
                    <div className="row g-4">
                      {/* LEFT SECTION */}
                      <div className="col-12 col-lg-6">


                        <div className="mb-4">
                          <Card
                            onClick={() => setShowProfile(true)}
                            className="mb-3"
                            style={{
                              width: "100%",
                              marginTop: isMobile ? "0" : "-40px",
                              background: "linear-gradient(135deg, #0E497B, #1A6FB3)",
                              color: "white",
                              borderRadius: "12px",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                              height: "60px",
                              cursor: "pointer",
                              transform: isHovered ? "scale(1.05)" : "scale(1)",
                              transition: "transform 0.25s ease",
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                          >
                            <div
                              className="d-flex flex-row justify-content-around align-items-center w-100"
                            >
                              <img
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  border: "3px solid rgba(255,255,255,0.7)",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                  marginTop: "-20px",
                                  transition: "transform 0.25s ease",
                                }}
                                src={
                                  authData?.employee?.photo
                                    ? `${authData?.employee?.photo}`
                                    : UserImg
                                }
                                alt="Your Image"
                              />
                              <p
                                style={{
                                  color: "white",
                                  fontWeight: 600,
                                  fontSize: "15px",
                                  marginLeft: "20px",
                                  marginTop: "-5px",
                                  userSelect: "none",
                                  marginBottom: 0,
                                }}
                              >
                                View Profile
                              </p>
                            </div>
                          </Card>
                        </div>

                        <div style={{ height: isMobile ? "350px" : "400px" }}>
                          <LeaveCalendar style={{ height: "100%" }} />
                        </div>
                        {
                          isMobile && (
                            <>
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                              <br />
                            </>
                          )
                        }
                      </div>

                      {/* RIGHT SECTION */}
                      <div className="col-12 col-lg-6" style={{ marginTop: isMobile ? "0" : "-10px" }}>
                        {/* <Card
                          onClick={() => setShowProfile(true)}
                          className="mb-3"
                          style={{
                            width: "100%",
                            marginTop: isMobile ? "0" : "-40px",
                            background: "linear-gradient(135deg, #0E497B, #1A6FB3)",
                            color: "white",
                            borderRadius: "12px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                            height: "60px",
                            cursor: "pointer",
                            transform: isHovered ? "scale(1.05)" : "scale(1)",
                            transition: "transform 0.25s ease",
                          }}
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                        >
                          <div
                            className="d-flex flex-row justify-content-around align-items-center w-100"
                          >
                            <img
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                border: "3px solid rgba(255,255,255,0.7)",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                marginTop: "-20px",
                                transition: "transform 0.25s ease",
                              }}
                              src={
                                authData?.employee?.photo
                                  ? `${authData?.employee?.photo}`
                                  : UserImg
                              }
                              alt="Your Image"
                            />
                            <p
                              style={{
                                color: "white",
                                fontWeight: 600,
                                fontSize: "15px",
                                marginLeft: "20px",
                                marginTop: "-5px",
                                userSelect: "none",
                                marginBottom: 0,
                              }}
                            >
                              View Profile
                            </p>
                          </div>
                        </Card> */}

                        <center>
                          <Badge
                            count={
                              celebrations.birthdays.length +
                              celebrations.work_anniversaries.length
                            }
                            color="#ff4d4f"
                          >
                            <Typography.Title
                              level={5}
                              className="w-100"
                              style={{
                                margin: 0,
                                color: "#0E497B",
                                fontWeight: 600,
                                fontSize: 14,
                                cursor: "pointer",
                                border: "1px solid #0E497B",
                                padding: "8px 16px",
                                borderRadius: 20,
                                textAlign: "center",
                                display: "block",
                              }}
                              onClick={() => setEventsModalVisible(true)}
                            >
                              🎉 Events Today
                            </Typography.Title>
                          </Badge>
                        </center>

                        <div className="text-center mt-2 mb-3">
                          {(authData?.is_birthday_today ||
                            authData?.is_wedding_today ||
                            authData?.is_work_anniversary_today) && (
                              <Button
                                type="primary"
                                onClick={() => setShowWishes((prev) => !prev)}
                                style={{
                                  backgroundColor: "#0E497B",
                                  borderColor: "#0E497B",
                                  borderRadius: "10px",
                                  fontWeight: 600,
                                  padding: "10px 18px",
                                }}
                              >
                                {showWishes ? "Hide Wishes" : "💌 View My Wishes"}
                              </Button>
                            )}
                        </div>

                        {showWishes && (
                          <Card
                            bordered={false}
                            className="mb-4"
                            style={{
                              borderRadius: "14px",
                              padding: isMobile ? "16px" : "24px",
                              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                              background: "#FFFFFF",
                            }}
                          >
                            <Typography.Title
                              level={4}
                              style={{
                                color: "#0E497B",
                                textAlign: "center",
                                marginBottom: "24px",
                                fontSize: isMobile ? "18px" : "24px",
                              }}
                            >
                              💌 My Wishes
                            </Typography.Title>

                            {mywishes?.length > 0 ? (
                              <div className="row g-3">
                                {mywishes.map((wish) => (
                                  <div key={wish.id} className="col-12 col-sm-12 col-xl-12">
                                    <Card
                                      hoverable
                                      style={{
                                        borderRadius: "12px",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                                        padding: "5px",
                                      }}
                                    >
                                      <div className="d-flex mb-3">
                                        <img
                                          src={`${wish.sender_photo}`}
                                          alt={wish.sender_name}
                                          style={{
                                            width: "52px",
                                            height: "52px",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            marginRight: "14px",
                                            flexShrink: 0,
                                          }}
                                        />
                                        <div>
                                          <Typography.Text strong style={{ fontSize: 15 }}>
                                            {wish.sender_name}
                                          </Typography.Text>
                                          <br />
                                          <Typography.Text
                                            type="secondary"
                                            style={{ fontSize: "13px" }}
                                          >
                                            {wish.occasion === "BIRTHDAY"
                                              ? "🎂 Birthday"
                                              : wish.occasion === "WORK_ANNIVERSARY"
                                                ? "🏆 Work Anniversary"
                                                : wish.occasion}
                                          </Typography.Text>
                                        </div>
                                      </div>

                                      <Typography.Paragraph
                                        style={{
                                          background: "#F5F8FA",
                                          borderRadius: "10px",
                                          padding: "14px",
                                          fontStyle: "italic",
                                          minHeight: "70px",
                                          fontSize: 14,
                                          marginBottom: "8px",
                                        }}
                                      >
                                        "{wish.message}"
                                      </Typography.Paragraph>

                                      <Typography.Text
                                        type="secondary"
                                        style={{
                                          fontSize: "12px",
                                          display: "block",
                                          textAlign: "right",
                                        }}
                                      >
                                        {new Date(wish.created_at).toLocaleDateString(
                                          "en-GB"
                                        )}
                                      </Typography.Text>
                                    </Card>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <p style={{ textAlign: "center", color: "#888" }}>
                                You haven't received any wishes yet ✨
                              </p>
                            )}
                          </Card>
                        )}

                        <div style={{
                          width: "100%",
                        }} >
                          <ViewAnnouncement />
                        </div>

                        {/* <div style={{
                          width: "100%",
                        }} >
                          <InduvidualAttendance />
                        </div> */}

                        <div style={{
                          width: "100%",
                        }}>
                          {leaveDetails && <LeaveSummary data={leaveDetails} />}
                        </div>

                        {/* ANNOUNCEMENTS */}
                        {/* <div style={{
                          width: "100%",
                        }} >
                          <ViewAnnouncement />
                        </div> */}
                      </div>
                    </div>
                  </div>

                  {/* MODALS */}
                  {/* EVENTS MODAL */}
                  <Modal
                    title="Events Today"
                    open={eventsModalVisible}
                    onCancel={() => setEventsModalVisible(false)}
                    footer={null}
                    width={isMobile ? "95%" : 900}
                    style={{ top: isMobile ? 20 : undefined }}
                  >
                    {celebrations.birthdays.length === 0 &&
                      celebrations.work_anniversaries.length === 0 ? (
                      <p>No events today 🎈</p>
                    ) : (
                      <>
                        {celebrations.birthdays.length > 0 && (
                          <Card
                            title="🎂 Birthdays"
                            size="small"
                            className="mb-3"
                          >
                            {celebrations.birthdays.map((emp) => (
                              <div key={emp.id}>
                                <ViewBirthDay employee={emp} />
                                <br />
                              </div>
                            ))}
                          </Card>
                        )}

                        {celebrations.work_anniversaries.length > 0 && (
                          <Card title="🏆 Work Anniversaries" size="small">
                            {celebrations.work_anniversaries.map((emp) => (
                              <WorkCard key={emp.id} employee={emp} />
                            ))}
                          </Card>
                        )}
                      </>
                    )}
                  </Modal>

                  {/* SEND WISH MODAL */}
                  <Modal
                    title={`Send Wish to ${selectedPerson
                      ? `${selectedPerson.user.first_name} ${selectedPerson.user.last_name}`
                      : ""
                      }`}
                    open={wishModalVisible}
                    onCancel={() => setWishModalVisible(false)}
                    onOk={handleSendWish}
                    okText="Send Wish"
                    width={isMobile ? "95%" : 520}
                    style={{ top: isMobile ? 20 : undefined }}
                  >
                    <TextArea
                      rows={4}
                      placeholder="Write your message..."
                      value={wishMessage}
                      onChange={(e) => setWishMessage(e.target.value)}
                      style={{
                        borderRadius: "8px",
                      }}
                    />
                  </Modal>
                </div>
              )
            }
          </>

        );

      // case "viewprofile":
      //   return <EmployeeProfile />
      case "applyMRF":
        return <CreateMrf onSubmitSuccess={() => setSelectedMenu("viewRequisitions")} />;
      case "viewRequisitions":
        return <EmployeeViewReq />;
      case "interview":
        return <InterviewPage />;
      case "holidays":
        return <Holidays />;
      case "offDayDutyApply":
        return <OffDay />;
      case "permissions":
        return <Permission />;
      case "leaves":
        return <Leaves />;
      case "leaveRequests":
        return <Teamleaves />;
      case "compoffRequests":
        return <TeamCompoff />;
      case "permissionRequests":
        return <TeamPermissions />;
      case "raiseTicket":
        return <RaiseTicket />;
      case "viewTicket":
        return <ViewTicket />;
      case "payslip":
        return <PaySlip />;
      case "teamattendance":
        return <TeamAttendance />;
      case "compoffcancel":
        return <WeekOffCancel />;
      case "myattendance":
        return <ViewEmpAttendance />;
      case "myrfc":
        return <MyRfc />;
      case "rfc":
        return <Rfc />;
      case "teamemployement":
        return <ProbationReview />;
      case "selfAssessment":
        return <SelfAssessment />;
      case "overall":
        return <OverallEmployees />;
      case "otavail":
        return <Otapplication />;
      case "otapproval":
        return <OtApprovals />
      case "tickets":
        return <ListTickets />
      case "showselfassessments":
        return <TeamAssessment />
      case "resignation":
        return <Resignation />
      case "resignationRequests":
        return <ResignationRequests />
      case "pips":
        return <Pips />
      case "orgchart":
        return <OrgChart />
      case "NocClearence":
        return <ListNoc />
      case "exitInterview":
        return <ExitInterview />
      case "onduty":
        return <PastOnduty />
      case "teamMembers":
        return <TeamMembers />
      case "applyOnduty":
        return <OnDutyAttendance />
      case "appliedOnDuty":
        return <AppliedOnDuty />
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      <DashboardHeader />

      {/* Mobile toggle */}
      {isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "10px 20px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px", color: "#0e497b" }} />}
            onClick={() => setDrawerVisible(true)}
          />
        </div>
      )}

      <Layout style={{ background: "#fff" }}>
        {!isMobile && (
          <Sider
            width={310}
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            theme="light"
            style={{
              background: "#fff",
              borderRight: "1px solid #f0f0f0",
              boxShadow: "2px 0 6px rgba(0,0,0,0.05)",
            }}
          >
            <style>{`
              .ant-menu { background: #fff !important; border-right: none !important; }
              .ant-menu-item, .ant-menu-submenu-title { font-weight: bold; color: #0e497b !important; transition: all 0.2s ease; }
              .ant-menu-item:hover, .ant-menu-submenu-title:hover { background-color: rgba(14,73,123,0.05) !important; color: #0e497b !important; }
              .ant-menu-item-selected { background-color: #0e497b !important; color: #fff !important; }
              .ant-menu-item-selected .anticon { color: #fff !important; }
              .ant-menu-submenu-open > .ant-menu-submenu-title { color: #0e497b !important; background-color: rgba(14,73,123,0.05) !important; }
            `}</style>
            <Menu
              mode="inline"
              selectedKeys={[selectedMenu]}
              onClick={({ key }) => setSelectedMenu(key)}
              style={{
                height: "100%",
                borderRight: 0,
                background: "#fff",
                fontWeight: "bold",
              }}
              items={menuItems}
            />
          </Sider>
        )}

        <Drawer
          title="Tabs"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
          footer={null}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedMenu]}
            onClick={({ key }) => {
              setSelectedMenu(key);
              setDrawerVisible(false);
            }}
            style={{
              height: "100%",
              borderRight: 0,
              background: "#fff",
              fontWeight: "bold",
            }}
            items={menuItems}
          />
        </Drawer>

        <Layout style={{ padding: isMobile ? "10px" : "24px", background: "#fff" }}>
          <Content style={{ background: "#fff" }}>{renderContent()}</Content>
        </Layout>
      </Layout>

      <Footer style={{ background: "#fff" }} />
    </Layout>
  );
}
